import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  class: "card-title d-flex align-item-center justify-content-end",
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table align-middle table-row-dashed fs-6 gy-3" }
const _hoisted_6 = { class: "text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_15 = { class: "" }

import { ref, onMounted, inject } from "vue";
import notification from "@/core/plugins/notification";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import { ReferralServiceType } from "@/core/types/ReferralServiceType";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import CreateReferralCodeForAccount from "@/projects/tenant/modules/accounts/components/modal/CreateReferralCodeForAccount.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountReferCode',
  setup(__props) {

const data = ref<any>([]);
const isLoading = ref(false);
const isUpdating = ref(false);
const createReferralCodeRef =
  ref<InstanceType<typeof CreateReferralCodeForAccount>>();
const accountDetails = inject(AccountInjectionKeys.ACCOUNT_DETAILS);

const setDefaultClient = async (item: any) => {
  isUpdating.value = true;
  try {
    await AccountService.setDefaultClient(item.accountId, item.code);
    notification.success();
    fetchData();
  } catch (error) {
    notification.danger();
    console.log(error);
  }
  isUpdating.value = false;
};

const addReferralCode = async () => {
  createReferralCodeRef.value?.show();
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await AccountService.getReferCode(accountDetails.value.id);
    data.value = res;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          (_ctx.$can('TenantAdmin'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                loading: isUpdating.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addReferralCode()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add Referral Code ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", _hoisted_6, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.linkName")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.referCode")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.accountType")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.linkType")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.lang")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.code), 1),
                    _createElementVNode("td", _hoisted_10, [
                      (item.serviceType != _unref(ReferralServiceType).Client)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.displaySummary.schema, (acc, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: _normalizeClass(["accountBadge", ['type1', 'type2', 'type3'][index % 3]]),
                                key: 'type_' + index
                              }, _toDisplayString(_ctx.$t("type.shortAccount." + acc.accountType)), 3))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (item.serviceType == _unref(ReferralServiceType).Client)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.displaySummary
                      .allowAccountTypes, (acc, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: _normalizeClass(["accountBadge", ['type1', 'type2', 'type3'][index % 3]]),
                                key: 'type_' + index
                              }, _toDisplayString(_ctx.$t("type.shortAccount." + acc.accountType)), 3))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_ctx.$t("type.accountRole." + item.serviceType)) + " ", 1),
                        (
                    item.serviceType == _unref(AccountRoleTypes).Client &&
                    item.isDefault == 1
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_el_tag, {
                                type: "success",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("status.default")), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(item.displaySummary.language == undefined
                  ? "undefined"
                  : _ctx.$t("type.language." + item.displaySummary.language)), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      (
                  item.serviceType == _unref(ReferralServiceType).Client &&
                  item.isDefault == 0
                )
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "success",
                            class: "small",
                            plain: "",
                            loading: isUpdating.value,
                            onClick: ($event: any) => (setDefaultClient(item))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.setDefault")), 1)
                            ]),
                            _: 2
                          }, 1032, ["loading", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(CreateReferralCodeForAccount, {
      ref_key: "createReferralCodeRef",
      ref: createReferralCodeRef,
      onFetchData: fetchData
    }, null, 512)
  ]))
}
}

})